export const SearchPhases = {
  INITIAL: 'initial',
  LOCATING: 'locating',
  LOADING: 'loading',
  COMPLETE: 'complete'
};